export default "__VITE_ASSET__DLG6qUqR__"